/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
import type { ItemCharacteristics } from "./item"
export let ItemClassCharacteristics = contentCatalog.items.classCharacteristics as Partial<Record<string, ItemCharacteristics>>

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    ItemClassCharacteristics: catalog.items.classCharacteristics as Partial<Record<string, ItemCharacteristics>>,
}), next => {
    ItemClassCharacteristics = next.ItemClassCharacteristics
})
